import React from "react"
import { Form, FormGroup } from "react-bootstrap"
import { Field } from "react-final-form"

function TextField({ label, name, placeholder, type, ...props }) {
  return (
    <Field name={name} component="input" placeholder={placeholder} type={type} className="form-control">
      {({ input, meta }) => {
        return (
          <FormGroup>
            <div className="d-flex flex-column">
              <label className="form-label">{label}</label>
              <Form.Control {...props} {...input} role="textbox" placeholder={label} />
            </div>
          </FormGroup>
        )
      }}
    </Field>
  )
}

export default TextField
